import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlatformSearchCpa',
  props: {
  modelValue: {
    type: String,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const store = useStore()

const suggestionData: any = computed(() => store.state.platforms)

const props = __props

const emits = __emit

const value: any = computed({
  set(val) {
    emits('update:modelValue', val)
  },
  get() {
    return props.modelValue
  },
})

const onChange = (item, options) => {
  if (item) {
    emits('update:modelValue', item)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    placeholder: "推广产品",
    style: {"width":"100%"},
    allowClear: true,
    "show-search": "",
    options: suggestionData.value,
    onChange: onChange
  }, null, 8, ["value", "options"]))
}
}

})